import React from 'react'
import ReactHtmlParser from 'react-html-parser'

import Container from '@mui/material/Container'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'

import { faqTextTypography, faqHTMLTypography } from '../../helpers/typographies'
import useWindowDimensions from '../../helpers/windowDimensions'
import { videoInsert } from '../../helpers/videos'
import { positionChangeWidthSm, swipelyticsTurquoise, swipelyticsPink, aiReviewRate, aiReviewDiscount, friendReviewRate, friendReviewDiscount, expertReviewRate, expertReviewDiscount } from '../../helpers/variableDefaults.js'


// FAQ Page
const FAQ = (props) => {

  // console.log('props.fromComponent ->', props.fromComponent)
  // Destructure Props
  const { fromComponent } = props

  // Window Dimensions
  const { height, width } = useWindowDimensions()
  // console.log('width ->', width)

  // URL Path
  // const urlPath = window.location.pathname

  // Standard Question and Answer Element
  // Here and not in a helper file for convenience — it only appears here
  const questionAnswerComponent = (question = '', answer = '', expandedDefault = false, isVideo = false, videoLink = '', writtenInstructions = '', altText = '', cardWidth = '95%' , width = 0) => {
    return (
      // Instantiate an Accordion
      <Accordion
        defaultExpanded={expandedDefault}
        sx={{ 
          width: '100%',
          boxShadow: 4, 
        }}
      >
        {/* Question appears on Accordion Summary */}
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          sx={{
            backgroundColor: 'lightblue',
            border: 2,
            borderBottom: 2,
            borderColor: 'black',
          }}
        >
          <Typography>
            <strong>{question}</strong>
          </Typography>
        </AccordionSummary>

        {/* Answer Appears in Accordion Details */}
        <AccordionDetails
          sx={{
            backgroundColor: 'lightyellow',
            // backgroundColor: 'mistyrose',
            // backgroundColor: 'lavenderblush',
            border: 2,
            borderTop: 0,
            borderColor: 'black',
            display: 'flex', flexDirection: 'column',
          }}
        >
          {/* {answer.length > 0 && faqTextTypography(answer, '18px', 'Lato')} */}
          {answer.length > 0 && faqHTMLTypography(answer, '18px', 'Lato')}
          {isVideo && videoInsert(videoLink, altText, cardWidth, width)}
          {writtenInstructions.length > 0 && faqTextTypography(writtenInstructions, '18px', 'Lato')}
        </AccordionDetails>

      </Accordion>
    )
  }

  return (
    <>
      {/* Helmet — for analytics, seo, and page title changing */}
      {/* {fromComponent === 'faq' && 
        seoPageTags(
          'FAQ'
        )
      } */}

      {/* FAQ Body */}
      <Container sx={{ 
        // backgroundColor: 'orange',
        // height: `calc(100vh - ${navbarHeight})`, 
        width: '100vw', 
        display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', 
      }}>

        {/* This Box is necessary for scrolling and view height normalization */}
        <Box
          sx={{
            // backgroundColor: 'orange',
            width: '100vw',
            height: '100%',
            maxHeight: '100%',
            overflow: 'auto',
            display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
          }}
        >

          {/* Box sets max width and new background color */}
          <Box
            sx={{
              backgroundColor: fromComponent === 'requestReview' ? '' : 'white',
              boxShadow: 4,
              mb: fromComponent === 'faq' ? 4 : 0, mt: 0, pt: (fromComponent === 'faq' || fromComponent === 'familyHQ') ? 4 : fromComponent === 'requestReview' ? 0 : width <= positionChangeWidthSm ? 4 : 6, pb: fromComponent === 'requestReview' ? 0 : 2,
              width: '100vw',
              display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start',
            }}
          >

            {/* Box sets smaller interior width for the question accordions */}
            <Box
              sx={{ 
                pb: fromComponent === 'requestReview' ? 0 : 8,
                width: .90, 
                maxWidth: fromComponent === 'requestReview' ? '400px' : '600px',
                height: '100%',
                overflow: 'auto',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              {/* Title */}
              {(fromComponent === 'home') && 
                <Typography>
                  <h3>FAQ</h3>
                </Typography>
              }

              {/* FAQ Accordions */}

              {/* Panel 1 */}
              {(fromComponent === 'faq' || fromComponent === 'home') && 
                questionAnswerComponent(
                  'What is Swipelytics?',
                  `
                    <div>
                      Swipelytics is a software service for optimizing dating profiles by 
                      gathering and implementing expert, friend, and AI feedback on images, 
                      bios, and the overall story that a profile tells about a person.
                    </div>
                  `,
                  true
                )
              }

              {/* Panel 2 */}
              {(fromComponent === 'faq' || fromComponent === 'home' || fromComponent === 'requestReview') && 
                questionAnswerComponent(
                  fromComponent === 'requestReview' ? 'What are the profile review types?' : 'What is a profile review?',
                  `
                    ${fromComponent === 'requestReview' ? 
      ``
      :
      `<div>
        A profile review is 
        <a href='/demo/carrie/hinge/mrbig/view-feedback' target="#" style="cursor:pointer; font-weight:bold; color: ${swipelyticsPink};">an item-by-item analysis</a>
        of whether a profile element (image, prompt, etc) enhances 
        or diminishes the story a profile tells about a person.
        There are <span style="font-weight:bold; color:black;">3 types</span> of profile reviews:
      </div>
      </br>` 
    }
                    <div>
                      <span style="font-weight:bold; color:black;">Expert Review</span>: 
                      Feedback from a human expert. There are two types of experts: 
                      </br>
                      </br>
                      1) <span style="text-decoration:underline; color:black;">Dating Coaches</span> 
                      — people well-versed in what makes a profile effective 
                      </br>
                      2) <span style="text-decoration:underline; color:black;">Hotties</span> 
                      — the type of person you hope your profile will impress. 
                      </br>
                      </br>
                      Expert reviews are 
                      <span style="text-decoration:underline; color:black;">completed within 24 hours</span> 
                      and are valuable for both pinpointing dealbreaker images and
                      prompts, and curating a story that a profile tells about a person.
                    </div>
                    </br>
                    <div>
                      <span style="font-weight:bold; color:black;">AI Review</span>: 
                      Feedback from an AI Assistant. AI reviews are typically 
                      <span style="text-decoration:underline; color:black;">completed within 5 minutes</span> 
                      and are very good at pinpointing low-quality or 
                      dealbreaker images and prompts, but they are less effective at shaping
                      an overall story that a profile tells about a person. In general, it's
                      good practice to start with AI reviews and then move to Friend or Expert
                      reviews for fine-tuning
                    </div>
                    </br>
                    <div>
                      <span style="font-weight:bold; color:black;">Friend Review</span>: 
                      Feedback from people you trust. Someone familiar with the various
                      facets of your character will have unique insight into what makes 
                      you attractive and how to better-display it.
                    </div>
                  `,
                  false
                )
              }
              

              {/* Panel 3 */}
              {(fromComponent === 'faq' || fromComponent === 'home') && 
                questionAnswerComponent(
                  'What is the Swipelytics process?',
                  `
                    <div>
                      <span style="font-weight:bold; color:black;">1) Upload media</span> 
                      (images, videos, etc) and bio elements (about me, prompts/responses, vital info).
                    </div>
                    </br>
                    <div>
                      <span style="font-weight:bold; color:black;">2) Create a profile</span> 
                      using these elements. Profile interfaces mimic those of Hinge, Bumble, or Tinder.
                    </div>
                    </br>
                    <div>
                      <span style="font-weight:bold; color:black;">3) Press the 'Get Feedback' button</span> 
                      and choose 'Expert Feedback', 'Friend Feedback', or 'AI Feedback'
                    </div>
                    </br>
                    <div>
                      <span style="font-weight:bold; color:black;">4) Receive an email</span> 
                      when the feedback is ready
                    </div>
                    </br>
                    <div>
                      <span style="font-weight:bold; color:black;">5) Workshop your profile</span> 
                      by implementing feedback and asking for more feedback until 
                      you're confident that your most attractive self is on display.
                    </div>
                  `,
                  false
                )
              }
              
              {/* Panel 4 */}
              {/* {(fromComponent === 'faq' || fromComponent === 'home') && 
                questionAnswerComponent(
                  'How does the expert feedback work',
                  `
                    <div>
                      TK
                    </div>
                  `,
                  false
                )
              } */}
              
              {/* Panel 5 */}
              {(fromComponent === 'faq' || fromComponent === 'home') && 
                questionAnswerComponent(
                  'How much does Swipelytics cost',
                  `
                    <div>
                      <span style="font-weight:bold; color:black;">Sign up</span> is <span style="font-weight:bold; color:black;">FREE</span>
                    </div>
                    </br>
                    <div>
                      <span style="font-weight:bold; color:black;">Friend feedback</span> ${(friendReviewRate * friendReviewDiscount) === 0 ? `is` : `costs`} <span style="font-weight:bold; color:black;">${(friendReviewRate * friendReviewDiscount) === 0 ? `FREE` : `$${Math.round(friendReviewRate * friendReviewDiscount)}`}</span>${(friendReviewRate * friendReviewDiscount) === 0 ? `` : ` per review`}
                    </div>
                    </br>
                    <div>
                      <span style="font-weight:bold; color:black;">AI feedback</span> ${(aiReviewRate * aiReviewDiscount) === 0 ? `is` : `costs`} <span style="font-weight:bold; color:black;">${(aiReviewRate * aiReviewDiscount) === 0 ? `FREE` : `$${Math.round(aiReviewRate * aiReviewDiscount)}`}</span>${(aiReviewRate * aiReviewDiscount) === 0 ? `` : ` per review`}
                    </div>
                    </br>
                    <div>
                      <span style="font-weight:bold; color:black;">Expert feedback</span> ${(expertReviewRate * expertReviewDiscount) === 0 ? `is` : `starts at`} <span style="font-weight:bold; color:black;">${(expertReviewRate * expertReviewDiscount) === 0 ? `FREE` : `$${Math.round(expertReviewRate * expertReviewDiscount)}`}</span>${(expertReviewRate * expertReviewDiscount) === 0 ? `` : ` per review`}
                    </div>
                  `,
                  false
                )
              }


            </Box>
          </Box>
        </Box>
      </Container>
    </>
  )
}

export default FAQ